// extracted by mini-css-extract-plugin
export var card = "_az-0";
export var failedIcon = "_az-4";
export var failedIconBadge = "_az-3";
export var icon = "_az-1";
export var successIcon = "_az-2";